import "./PillsList.css";

import { PillData } from "../../../models";
import { TextLink } from "../../navigation";
import { Pill } from "..";

interface PillsListProps {
  pills: PillData[];
  linkText: string;
  readOnly?: boolean;
  linkOnClick: () => void;
}

export const PillsList = ({ pills, linkText, readOnly = false, linkOnClick }: PillsListProps): JSX.Element => {
  return (
    <div className="PillsListContainer">
      <div className="PillsList">
        {pills.map((pill) => (
          <Pill key={pill.key} label={pill.label} variant="grey-alternate" fontWeight={300} />
        ))}
        {!readOnly && (
          <TextLink onAction={linkOnClick}>
            <p className="body1">
              <b>{linkText}</b>
            </p>
          </TextLink>
        )}
      </div>
    </div>
  );
};
